import { Switch as SwitchPrimitive } from "radix-ui";
import * as React from "react";

import { cn } from "@/lib/utils";

function Switch({
  className,
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        "tw:peer tw:inline-flex tw:h-7 tw:w-12 tw:shrink-0 tw:items-center tw:rounded-full tw:border-2 tw:border-transparent tw:shadow-xs tw:ring-ring/10 tw:outline-ring/50 tw:transition-[color,box-shadow] tw:focus-visible:ring-4 tw:focus-visible:outline-hidden tw:focus-visible:outline-1 tw:disabled:cursor-not-allowed tw:disabled:opacity-50 tw:aria-invalid:focus-visible:ring-0 tw:data-[state=checked]:bg-brand tw:data-[state=unchecked]:bg-input tw:dark:ring-ring/20 tw:dark:outline-ring/40",
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          "tw:pointer-events-none tw:block tw:size-5.5 tw:rounded-full tw:bg-background tw:ring-0 tw:shadow-lg tw:transition-transform tw:data-[state=checked]:translate-x-5 tw:data-[state=unchecked]:translate-x-0 tw:rtl:data-[state=checked]:-translate-x-5",
        )}
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
